import { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  setOrganizationCreated,
  getcountry,
  getcity,
  categorylist,
  createorg,
  updateorg,
} from "../../../store/Organization/organizationSlice";
import { pincodes_by_state } from "../../../store/User/ProfileSlice";
import { updatenotificationdata } from "../../../store/Admin/Common/CommonSlice";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import PhoneNumberField from "../../../components/common/PhoneNumberField";
import { isValidPhoneNumber } from "react-phone-number-input";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { Button } from "@/components/ui/button"

// The contact number is stored without its country code (contact_number) and
// the dial code alongside it (contact_country_code); toE164 recombines them
// for PhoneNumberField, splitPhone splits them again on save.
import { splitPhone, toE164 } from "../../../utils/phone";

// const validationSchema = Yup.object().shape({
//   pan: Yup.string()
//     .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN number")
//     .required("PAN is required"),
//   gst: Yup.string()
//     .matches(
//       /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
//       "Invalid GST number"
//     )
//     .required("GST is required"),
//   country: Yup.string().required("Country is required"),
//   city: Yup.string().required("City is required"),
//   address1: Yup.string().required("Address is required"),
//   address2: Yup.string(),
//   contact_number: Yup.string()
//     .matches(/^\+?[1-9][0-9]{7,14}$/, "Invalid phone number") .matches(/^\d{10}$/, "Invalid phone number")
//     .required("Contact number is required"),
//   contact_person: Yup.string().required("Contact person name is required"),
//   category: Yup.string().required("Category is required"),
// });
const validationSchema = Yup.object().shape({
  pan: Yup.string()
    .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN number")
    .required("PAN is required"),
  gst: Yup.string()
    .matches(
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
      "Invalid GST number"
    )
    .test("pan-match", "PAN inside GST must match the entered PAN", function (value) {
      const { pan } = this.parent;
      if (!value || !pan) return true;
      return value.substring(2, 12) === pan;
    }),
  adhaar: Yup.string(),
  country: Yup.string().required("Country is required"),
  city: Yup.string().required("City is required"),
  address1: Yup.string().required("Address is required"),
  address2: Yup.string(),
  contact_number: Yup.string()
    .required("Phone number is required")
    .test("valid-phone", "Invalid phone number", (value) =>
      value ? isValidPhoneNumber(value) : false
    ),
  contact_person: Yup.string().required("Contact person name is required"),
  category: Yup.string().required("Category is required"),
});
export default function Organizationadd(props) {
  const [country, setCountry] = useState([]);
  const [city, setCity] = useState([]);
  const [category, setCategory] = useState([]);
  const [selectedCountryId, setSelectedCountryId] = useState("");
  const [propsselected, setPropsselected] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const[selectedcity, setSelectedCity] = useState(props?.instance?.instance?.user_details?.[0]?.city || props?.instance?.instance?.city_name );
  // cityArea resolved from the user's pincode, and the matching city option's _id.
  const [pincodeCityArea, setPincodeCityArea] = useState("");
  const [resolvedCityId, setResolvedCityId] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  console.log(props);
  useEffect(() => {
    dispatch(getcountry())
      .then((res) => {
        setCountry(res?.payload?.data);
      })
      .catch((err) => {
        console.error(err);
      });
    dispatch(categorylist())
      .then((res) => {
        setCategory(res?.payload?.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [dispatch]);
  // useEffect(() => {
  //   country?.filter((item) => {
  //     // if(item._id === props?.instance?.instance?.country){
  //       // setPropsselected(item.name)
  //       console.log("jojo",item)
  //     // }
  //   })
  // },[props])
  useEffect(() => {
    console.log(props?.instance?.instance);
    if (props?.instance?.instance?.country_id) {
      dispatch(getcity(props?.instance?.instance?.country_id))
        .then((res) => {
          setCity(res?.payload?.data);
          setSelectedCountryId(props?.instance?.instance?.country_id);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [props?.instance?.instance?.country_id]);

  // Resolve the City from the user's pincode so the City reflects the pincode
  // (e.g. 110037 -> NEW DELHI) instead of the stored org city.
  useEffect(() => {
    const pin = String(props?.instance?.instance?.user_details?.[0]?.pincode || "");
    if (!/^\d{6}$/.test(pin)) return;
    dispatch(pincodes_by_state(pin)).then((res) => {
      const cityArea = res?.payload?.data?.data?.[0]?.cityArea;
      if (cityArea) {
        setPincodeCityArea(cityArea);
        setSelectedCity(cityArea);
      }
    });
  }, [props?.instance?.instance?.user_details?.[0]?.pincode]);

  // Match the pincode-API's cityArea against a loaded city option by name.
  const findCityMatch = (cities, ...candidates) => {
    for (const candidate of candidates) {
      if (!candidate?.trim()) continue;
      const val = candidate.toLowerCase().trim();
      const exact = cities.find((c) => c.cityName?.toLowerCase() === val);
      if (exact) return exact;
      const partial = cities.find((c) => c.cityName?.toLowerCase().includes(val));
      if (partial) return partial;
    }
    return null;
  };

  // Resolve the entered pincode's city area via /pincodes_by_state and select the
  // matching option in the (already-loaded) city dropdown. The dropdown value is a
  // city _id, so the API's cityArea is matched against the loaded city names.
  const selectCityFromPincode = (pincode, cities, setFieldValue) => {
    if (!/^\d{6}$/.test(String(pincode || "")) || !cities?.length) return;
    dispatch(pincodes_by_state(pincode)).then((res) => {
      const cityArea = res?.payload?.data?.data?.[0]?.cityArea;
      if (!cityArea) return;
      const match = findCityMatch(cities, cityArea);
      if (match) {
        setFieldValue("city", match._id);
        setSelectedCity(match.cityName);
      }
    });
  };

  // Once the city options and the pincode-resolved cityArea are both available, pick the
  // matching option so the City field holds a real city _id (valid on save & shown selected).
  useEffect(() => {
    if (!pincodeCityArea || !city?.length) return;
    const match = findCityMatch(city, pincodeCityArea);
    if (match) {
      setResolvedCityId(match._id);
      setSelectedCity(match.cityName);
    }
  }, [pincodeCityArea, city]);

  const inst = props?.instance?.instance;
  // Address section is driven by the org's user (user_details), keeping "Address Lane"
  // from addresslane and "Address Lane 2" from address (same convention as Profile/KYC).
  const ud = inst?.user_details?.[0] || {};
  const hasGst = !!inst?.gst;
  const hasAdhaar = !!inst?.adhaar;

  console.log(inst, "org data");
  let initialValues = {
    org_name: inst?.org_name || "",
    pan: inst?.pan || "",
    gst: inst?.gst || "",
    adhaar: inst?.adhaar || "",
    country: inst?.country_id || "",
    // City field prefers the pincode-resolved city option (via enableReinitialize),
    // falling back to the org city_id until it resolves.
    city: resolvedCityId || inst?.city_id || "",
    // address1: inst?.address1 || "",
    // address2: inst?.address2 || "",
    // pincode: inst?.pincode || "",
    address1: ud?.addresslane || "",
    address2: ud?.address || "",
    pincode: ud?.pincode || "",
    contact_number: toE164(inst?.contact_number || "", inst?.contact_country_code),
    contact_person: inst?.contact_person || "",
    // The org's saved category wins; D is the fallback when it has none yet.
    category: inst?.category || "D",
    user_id: inst?._id,
  };

  const handlecancel = (formikBag) => {
    setSelectedCity(selectedcity || inst?.city_name);
    formikBag.resetForm({
      values: {
        org_name: inst?.org_name || "",
        pan: inst?.pan || "",
        gst: inst?.gst || "",
        adhaar: inst?.adhaar || "",
        country: inst?.country_id || "",
        city: resolvedCityId || inst?.city_id || "",
        // address1: inst?.address1 || "",
        // address2: inst?.address2 || "",
        // pincode: inst?.pincode || "",
        address1: ud?.addresslane || "",
        address2: ud?.address || "",
        pincode: ud?.pincode || "",
        contact_number: toE164(inst?.contact_number || "", inst?.contact_country_code),
        contact_person: inst?.contact_person || "",
        category: inst?.category || "D",
      },
    });
    setIsEditing(false);
    dispatch(setOrganizationCreated(false));
  };

  // const handleCountryChange = (e, setFieldValue) => {
  //   console.log("hi")
  //   const selectedOption = e.target.options[e.target.selectedIndex]
  //   const countryId = selectedOption.getAttribute('data-id')
  //   const countryName = selectedOption.value
  //   setSelectedCountryId(countryId)
  //   setFieldValue("country", countryName)
  //   console.log("countryId", countryId)
  //   dispatch(getcity(countryId))
  //     .then((res) => {
  //       setCity(res?.payload?.data)
  //       setSelectedCountryId(countryId)
  //     })
  //     .catch((err) => {
  //       console.error(err)
  //     })
  // }
  const handleCountryChange = (e, setFieldValue) => {
    const selectedOption = e.target.options[e.target.selectedIndex];
    const countryId = selectedOption.getAttribute("data-id");
    const countryName = selectedOption.value;

    setFieldValue("country", countryName);
    setFieldValue("city", "");
    setSelectedCity("");
    setSelectedCountryId(countryId);

    dispatch(getcity(countryId))
      .then((res) => {
        setCity(res?.payload?.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleSubmit = (values, { setSubmitting }) => {
    console.log(values);
    const countryId = values.country || props?.instance?.instance?.country_id
    const cityId = values.city || props?.instance?.instance?.city_id
    const parsedPhone = splitPhone(values.contact_number);
    const formattedValues = {
      org_id: inst?._id,
      // Pass through the org's user id list (from list_org) so update_org keeps the
      // members. Guard against a missing / non-array value.
      users: Array.isArray(inst?.users)
        ? inst.users
        : inst?.users
        ? [inst.users]
        : [],
      org_name: values?.org_name,
      pan: values?.pan,
      gst: values?.gst || undefined,
      adhaar: values?.adhaar || undefined,
      kam_id: inst?.kam_id || null,
      // Stored without the country code (e.g. "8287259604"), the dial code
      // travelling beside it in contact_country_code.
      contact_number: parsedPhone ? parsedPhone.nationalNumber : values?.contact_number,
      contact_country_code: parsedPhone
        ? parsedPhone.countryCode
        : inst?.contact_country_code,
      country_id: countryId,
      city_id: cityId,
      address1: values?.address1,
      address2: values.address2,
      pincode: values.pincode,
      contact_person: values.contact_person,
      category: values.category,
      kyc_status: inst?.kyc_status,
      assign_credit_limit: inst?.assign_credit_limit,
      credit_limit: inst?.credit_limit,
    };

    console.log("Form submitted with values:", formattedValues);

    dispatch(updateorg(formattedValues))
      .then((res) => {
        // if(res.payload.statusCode === 200) {
        // if (res.payload.statusCode === 200) {
          console.log("Organization updated:", res.payload);
        setIsEditing(false);
        dispatch(setOrganizationCreated(false));
        dispatch(updatenotificationdata(res?.payload))
        toast.success(
          res?.payload?.message || "Organization data updated successfully"
        );
        // dispatch(props.dispatchAttachment(formattedValues));
        // }
        // navigate('/organization-management')
        // }
        setSubmitting(false);
      })
      .catch((err) => {
        console.error("Error creating organization:", err);
        dispatch(updatenotificationdata(err?.payload));
        setSubmitting(false);
      });
  };
  console.log(propsselected, "propsselected");
  const baseFieldClass =
    "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500";
  // Always-locked fields (org name, pan, gst, country): grey in every mode.
  const lockedFieldClass = `${baseFieldClass} bg-gray-100 text-gray-500 cursor-not-allowed`;
  // Editable fields: grey while viewing, white once Edit is clicked.
  const editableFieldClass = `${baseFieldClass} ${
    isEditing ? "bg-white" : "bg-gray-100 text-gray-500 cursor-not-allowed"
  }`;
  return (
    <div className="w-full max-w-4xl">
      <ToastContainer position="top-center" hideProgressBar />
      <div className="bg-white rounded-lg shadow-lg">
        <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
          <h2 className="text-xl font-semibold text-gray-800">
            Organization Details
          </h2>
          {!isEditing && (
            <button
              onClick={() => setIsEditing(true)}
              variant="outline"
              size="sm"
              className="bg-black text-white py-1 px-5 rounded-md hover:bg-yellow-600 transition duration-300 ease-in-out"
            >
              Edit
            </button>
          )}
        </div>
        <Formik
          initialValues={initialValues}
          enableReinitialize
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, setFieldValue, values, resetForm }) => (
            <Form className="p-6">
              <div className="grid grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-6">
                <div>
                  <label
                    htmlFor="org_name"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Organization Name
                  </label>
                  <Field
                    type="text"
                    name="org_name"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-100 text-gray-500 cursor-not-allowed"
                    readOnly={true}
                  />
                </div>

                <div>
                  <label
                    htmlFor="pan"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    PAN <span className="text-red-500">*</span>
                  </label>
                  <Field
                    type="text"
                    name="pan"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-100 text-gray-500 cursor-not-allowed"
                    placeholder="Enter PAN number"
                    readOnly={true}
                  />
                  <ErrorMessage
                    name="pan"
                    component="div"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>

                {/* GST Field — only when org has GST */}
                {hasGst && (
                  <div>
                    <label
                      htmlFor="gst"
                      className="block text-sm font-medium text-gray-700 mb-1"
                    >
                      GST
                    </label>
                    <Field
                      type="text"
                      name="gst"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-100 text-gray-500 cursor-not-allowed"
                      placeholder="Enter GST number"
                      readOnly={true}
                    />
                    <ErrorMessage
                      name="gst"
                      component="div"
                      className="text-red-500 text-sm mt-1"
                    />
                  </div>
                )}

                {/* Aadhaar Field — only when org has Aadhaar */}
                {hasAdhaar && (
                  <div>
                    <label
                      htmlFor="adhaar"
                      className="block text-sm font-medium text-gray-700 mb-1"
                    >
                      Aadhaar
                    </label>
                    <Field
                      type="text"
                      name="adhaar"
                      onChange={(e) =>
                        isEditing && setFieldValue(e.target.name, e.target.value)
                      }
                      className={editableFieldClass}
                      placeholder="Aadhaar reference"
                      readOnly={!isEditing}
                    />
                    <ErrorMessage
                      name="adhaar"
                      component="div"
                      className="text-red-500 text-sm mt-1"
                    />
                  </div>
                )}

                <div>
                  <label
                    htmlFor="country"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Country <span className="text-red-500">*</span>
                  </label>
                  <Field
                    as="select"
                    name="country"
                    // values={props?.instance?.instance?.country_name}
                    onChange={(e) => {
                      if (isEditing) {
                        if (e.target.name === "country") {
                          handleCountryChange(e, setFieldValue);
                        } else {
                          setFieldValue(e.target.name, e.target.value);
                        }
                      }
                    }}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-100 text-gray-500 cursor-not-allowed"
                    disabled={true}
                  >
                    <option value={props?.instance?.instance?.country_id}>
                      {props?.instance?.instance?.country_name
                        ? props.instance.instance.country_name
                        : "Select a country"}
                    </option>
                    {country?.map((item) => (
                      <option
                        key={item._id}
                        value={item._id}
                        data-id={
                          item._id || props?.instance?.instance?.country_id
                        }
                      >
                        {item.name}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage
                    name="country"
                    component="div"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>

                <div>
                  <label
                    htmlFor="city"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    City <span className="text-red-500">*</span>
                  </label>

                  <Field
                    as="select"
                    name="city"
                    onChange={(e) =>
                      isEditing && setFieldValue("city", e.target.value)
                    }
                    className={editableFieldClass}
                    disabled={!isEditing}
                  >
                    <option value="">
                      {selectedcity|| "Select a city"}
                    </option>
                    {city?.map((item) => (
                      <option   key={item._id} value={item._id}>
                        {item.cityName}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage
                    name="city"
                    component="div"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>
                 {/* <div>
                   <label htmlFor="country" className="block text-sm font-medium text-gray-700 mb-1">
                    Country
                   </label>
                   <Field
                    as="select"
                    name="country"
                    onChange={(e) => {
                      if (isEditing) {
                        handleCountryChange(e, setFieldValue)
                      }
                    }}
                    value={values.country || props?.instance?.instance?.country_id}
                    className={editableFieldClass}
                    disabled={!isEditing}
                  >
                    <option value={props?.instance?.instance?.country_id}>
                      {props?.instance?.instance?.country_name || "Select a country"}
                    </option>
                    {country?.map((item) => (
                      <option key={item._id} value={item._id} data-id={item._id}>
                        {item.name}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage name="country" component="div" className="text-red-500 text-sm mt-1" />
                </div>

                <div>
                  <label htmlFor="city" className="block text-sm font-medium text-gray-700 mb-1">
                    City
                  </label>
                  <Field
                    as="select"
                    name="city"
                    onChange={(e) => isEditing && setFieldValue("city", e.target.value)}
                    value={values.city || props?.instance?.instance?.city_id}
                    className={editableFieldClass}
                    disabled={!isEditing}
                  >
                    <option value={props?.instance?.instance?.city_id}>
                      {props?.instance?.instance?.city_name || "Select a city"}
                    </option>
                    {city?.map((item) => (
                      <option key={item._id} value={item._id}>
                        {item.cityName}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage name="city" component="div" className="text-red-500 text-sm mt-1" />
                </div> */}
                <div>
                  <label
                    htmlFor="address1"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Address Lane <span className="text-red-500">*</span>
                  </label>
                  <Field
                    type="text"
                    name="address1"
                    values={props.instance.instance.address1}
                    onChange={(e) =>
                      isEditing && setFieldValue(e.target.name, e.target.value)
                    }
                    className={editableFieldClass}
                    placeholder="Enter address line 1"
                    readOnly={!isEditing}
                  />
                  <ErrorMessage
                    name="address1"
                    component="div"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>

                <div>
                  <label
                    htmlFor="address2"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Address Lane 2
                  </label>
                  <Field
                    type="text"
                    name="address2"
                    values={props.instance.instance.address2}
                    onChange={(e) =>
                      isEditing && setFieldValue(e.target.name, e.target.value)
                    }
                    className={editableFieldClass}
                    placeholder="Enter address line 2"
                    readOnly={!isEditing}
                  />
                </div>

                <div>
                  <label
                    htmlFor="pincode"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Pincode
                  </label>
                  <Field
                    type="text"
                    name="pincode"
                    values={props.instance.instance.pincode}
                    onChange={(e) => {
                      if (!isEditing) return;
                      setFieldValue(e.target.name, e.target.value);
                      selectCityFromPincode(e.target.value, city, setFieldValue);
                    }}
                    className={editableFieldClass}
                    placeholder="Enter pincode"
                    readOnly={!isEditing}
                  />
                </div>
                <div>
                  <label
                    htmlFor="contact_number"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Phone Number <span className="text-red-500">*</span>
                  </label>
                  <Field
                    name="contact_number"
                    component={PhoneNumberField}
                    placeholder="Enter phone number"
                    disabled={!isEditing}
                    lockCountry
                  />
                  <ErrorMessage
                    name="contact_number"
                    component="div"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>

                <div>
                  <label
                    htmlFor="contact_person"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Contact Person <span className="text-red-500">*</span>
                  </label>
                  <Field
                    type="text"
                    name="contact_person"
                    values={props.instance.instance.contact_person}
                    onChange={(e) =>
                      isEditing && setFieldValue(e.target.name, e.target.value)
                    }
                    className={editableFieldClass}
                    placeholder="Enter contact person name"
                    readOnly={!isEditing}
                  />
                  <ErrorMessage
                    name="contact_person"
                    component="div"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>

                <div>
                  <label
                    htmlFor="category"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Category <span className="text-red-500">*</span>
                  </label>
                  <Field
                    as="select"
                    name="category"
                    values={props.instance.instance.category}
                    onChange={(e) =>
                      isEditing && setFieldValue(e.target.name, e.target.value)
                    }
                    className={editableFieldClass}
                    disabled={!isEditing}
                  >
                    <option value="">Select a category</option>
                    {category?.map((item) => (
                      <option key={item._id} value={item.category_name}>
                        {item.category_name}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage
                    name="category"
                    component="div"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>
              </div>

              {isEditing && (
                <div className="mt-6 flex justify-end space-x-4">
                  <button
                    type="button"
                    onClick={() => handlecancel({ resetForm })}
                    variant="outline"
                    className="bg-black text-white py-1 px-5 rounded-md hover:bg-yellow-600 transition duration-300 ease-in-out"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="bg-yellow-600 text-white py-1 px-5 rounded-md hover:bg-black transition duration-300 ease-in-out"
                  >
                    {isSubmitting ? "Saving..." : "Save"}
                  </button>
                </div>
              )}
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}
// import { useEffect, useState } from "react"
// import { Formik, Form, Field, ErrorMessage } from "formik"
// import * as Yup from "yup"
// import {
//   setOrganizationCreated,
//   getcountry,
//   getcity,
//   categorylist,
//   createorg,
//   updateorg,
// } from "../../../store/Organization/organizationSlice"
// import { updatenotificationdata } from "../../../store/Admin/Common/CommonSlice"
// import { useSelector } from "react-redux"
// import { useDispatch } from "react-redux"
// import { useNavigate } from "react-router-dom"
// // import { Button } from "@/components/ui/button"

// const validationSchema = Yup.object().shape({
//   pan: Yup.string()
//     .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN number")
//     .required("PAN is required"),
//   gst: Yup.string()
//     .matches(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/, "Invalid GST number")
//     .required("GST is required"),
//   country: Yup.string().required("Country is required"),
//   city: Yup.string().required("City is required"),
//   address1: Yup.string().required("Address is required"),
//   address2: Yup.string(),
//   contact_number: Yup.string()
//     .matches(/^\+?[1-9][0-9]{7,14}$/, "Invalid phone number")
//     .required("Contact number is required"),
//   contact_person: Yup.string().required("Contact person name is required"),
//   category: Yup.string().required("Category is required"),
// })
// export default function Organizationadd(props) {
//   const [country, setCountry] = useState([])
//   const [city, setCity] = useState([])
//   const [category, setCategory] = useState([])
//   const [selectedCountryId, setSelectedCountryId] = useState("")
//   const [propsselected, setPropsselected] = useState("")
//   const [isEditing, setIsEditing] = useState(false)
//   const [selectedcity, setSelectedCity] = useState(props?.instance?.instance?.city_name)
//   const dispatch = useDispatch()
//   const navigate = useNavigate()
//   console.log(props)
//   useEffect(() => {
//     dispatch(getcountry())
//       .then((res) => {
//         setCountry(res?.payload?.data)
//       })
//       .catch((err) => {
//         console.error(err)
//       })
//     dispatch(categorylist())
//       .then((res) => {
//         setCategory(res?.payload?.data)
//       })
//       .catch((err) => {
//         console.error(err)
//       })
//   }, [dispatch])
//   // useEffect(() => {
//   //   country?.filter((item) => {
//   //     // if(item._id === props?.instance?.instance?.country){
//   //       // setPropsselected(item.name)
//   //       console.log("jojo",item)
//   //     // }
//   //   })
//   // },[props])
//   useEffect(() => {
//     console.log(props?.instance?.instance)
//     if (props?.instance?.instance?.country_id) {
//       dispatch(getcity(props?.instance?.instance?.country_id))
//         .then((res) => {
//           setCity(res?.payload?.data)
//           setSelectedCountryId(props?.instance?.instance?.country_id)
//         })
//         .catch((err) => {
//           console.error(err)
//         })
//     }
//   }, [props?.instance?.instance?.country_id])

//   console.log(props?.instance.instance, "org data")
//   const initialValues = {
//     org_name: props?.instance?.instance?.org_name || "",
//     pan: props?.instance?.instance?.pan || "",
//     gst: props?.instance?.instance?.gst || "",
//     country: props?.instance?.instance?.country_id || "",
//     city: props?.instance?.instance?.city_id || "",
//     address1: props?.instance?.instance?.address1 || "",
//     address2: props?.instance?.instance?.address2 || "",
//     pincode: props?.instance?.instance?.pincode || "",
//     contact_number: props?.instance?.instance?.contact_number || "",
//     contact_person: props?.instance?.instance?.contact_person || "",
//     category: props?.instance?.instance?.category || "",
//     user_id: props?.instance?.instance?._id,
//   }

//   const handlecancel = (formikBag) => {
//     setSelectedCity(props?.instance?.instance?.city_name)
//     formikBag.resetForm({
//       values: {
//         ...initialValues,
//         country: props.instance.instance.country_id,
//         city: props.instance.instance.city_id,
//       },
//     })
//     setIsEditing(false)
//     dispatch(setOrganizationCreated(false))
//   }

//   // const handleCountryChange = (e, setFieldValue) => {
//   //   console.log("hi")
//   //   const selectedOption = e.target.options[e.target.selectedIndex]
//   //   const countryId = selectedOption.getAttribute('data-id')
//   //   const countryName = selectedOption.value
//   //   setSelectedCountryId(countryId)
//   //   setFieldValue("country", countryName)
//   //   console.log("countryId", countryId)
//   //   dispatch(getcity(countryId))
//   //     .then((res) => {
//   //       setCity(res?.payload?.data)
//   //       setSelectedCountryId(countryId)
//   //     })
//   //     .catch((err) => {
//   //       console.error(err)
//   //     })
//   // }
//   // const handleCountryChange = (e, setFieldValue) => {
//   //   const selectedOption = e.target.options[e.target.selectedIndex]
//   //   const countryId = selectedOption.value // Use value directly as it contains the ID

//   //   // Set the country ID
//   //   setFieldValue("country", countryId)
//   //   setSelectedCity("")
//   //   setSelectedCountryId(countryId)

//   //   // Clear city when country changes
//   //   setFieldValue("city", "")

//   //   dispatch(getcity(countryId))
//   //     .then((res) => {
//   //       setCity(res?.payload?.data)
//   //     })
//   //     .catch((err) => {
//   //       console.error(err)
//   //     })
//   // }
//   const handleCountryChange = (e, setFieldValue) => {
//     const selectedOption = e.target.options[e.target.selectedIndex];
//     const countryId = selectedOption.getAttribute("data-id");
//     const countryName = selectedOption.value;

//     // Set the selected country and clear the city
//     setFieldValue("country", countryName);
//     // setFieldValue("city", ""); // Clear the city field
//     setSelectedCity("");
//     setSelectedCountryId(countryId);

//     // Fetch cities based on the selected country
//     dispatch(getcity(countryId))
//       .then((res) => {
//         setCity(res?.payload?.data);
//       })
//       .catch((err) => {
//         console.error(err);
//       });
//   };

//   const handleSubmit = (values, { setSubmitting }) => {
//     // If country/city weren't changed, use the original IDs
//     const countryId = values.country || props?.instance?.instance?.country_id
//     const cityId = values.city || props?.instance?.instance?.city_id

//     const formattedValues = {
//       org_id: props?.instance?.instance?._id,
//       org_name: values?.org_name,
//       pan: values?.pan,
//       gst: values?.gst,
//       kam_id: props?.instance?.instance?.kam_id || null,
//       contact_number: values?.contact_number,
//       country_id: countryId,
//       city_id: cityId,
//       address1: values?.address1,
//       address2: values.address2,
//       pincode: values.pincode,
//       contact_person: values.contact_person,
//       category: values.category,
//       kyc_status: props.instance.instance.kyc_status,
//       assign_credit_limit: props.instance.instance.assign_credit_limit,
//       credit_limit: props.instance.instance.credit_limit,
//     }

//     console.log("Form submitted with values:", formattedValues)

//     dispatch(updateorg(formattedValues))
//       .then((res) => {
//         console.log("Organization updated:", res.payload)
//         setIsEditing(false)
//         dispatch(setOrganizationCreated(false))
//         dispatch(updatenotificationdata(res?.payload))
//         setSubmitting(false)
//       })
//       .catch((err) => {
//         console.error("Error creating organization:", err)
//         dispatch(updatenotificationdata(err?.payload))
//         setSubmitting(false)
//       })
//   }
//   console.log(propsselected, "propsselected")
//   return (
//     <div className="w-full max-w-4xl mx-auto p-6">
//       <div className="bg-white rounded-lg shadow-lg">
//         <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
//           <h2 className="text-xl font-semibold text-gray-800">Organization Details</h2>
//           {!isEditing && (
//             <button
//               onClick={() => setIsEditing(true)}
//               variant="outline"
//               size="sm"
//               className="bg-black text-white py-1 px-5 rounded-md hover:bg-yellow-600 transition duration-300 ease-in-out"
//             >
//               Edit
//             </button>
//           )}
//         </div>
//         <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
//           {({ isSubmitting, setFieldValue, values, resetForm }) => (
//             <Form className="p-6">
//               <div className="grid grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-6">
//                 <div>
//                   <label htmlFor="org_name" className="block text-sm font-medium text-gray-700 mb-1">
//                     Organization Name
//                   </label>
//                   <Field
//                     type="text"
//                     name="org_name"
//                     values={props.instance.instance.org_name}
//                     className={editableFieldClass}
//                     readOnly={true}
//                   />
//                 </div>

//                 <div>
//                   <label htmlFor="pan" className="block text-sm font-medium text-gray-700 mb-1">
//                     PAN
//                   </label>
//                   <Field
//                     type="text"
//                     name="pan"
//                     values={props.instance.instance.pan}
//                     onChange={(e) => isEditing && setFieldValue(e.target.name, e.target.value)}
//                     className={editableFieldClass}
//                     placeholder="Enter PAN number"
//                     readOnly={!isEditing}
//                   />
//                   <ErrorMessage name="pan" component="div" className="text-red-500 text-sm mt-1" />
//                 </div>

//                 <div>
//                   <label htmlFor="gst" className="block text-sm font-medium text-gray-700 mb-1">
//                     GST
//                   </label>
//                   <Field
//                     type="text"
//                     name="gst"
//                     values={props.instance.instance.gst}
//                     onChange={(e) => isEditing && setFieldValue(e.target.name, e.target.value)}
//                     className={editableFieldClass}
//                     placeholder="Enter GST number"
//                     readOnly={!isEditing}
//                   />
//                   <ErrorMessage name="gst" component="div" className="text-red-500 text-sm mt-1" />
//                 </div>
                        
//                 <div>
//                   <label htmlFor="country" className="block text-sm font-medium text-gray-700 mb-1">
//                     Country
//                   </label>
//                   <Field
//                     as="select"
//                     name="country"
//                     // onChange={(e) => {
//                     //   if (isEditing) {
//                     //     handleCountryChange(e, setFieldValue)
//                     //   }
//                     // }}
//                     onChange={(e) => {
//                                             if (isEditing) {
//                                               if (e.target.name === "country") {
//                                                 handleCountryChange(e, setFieldValue);
//                                                 setFieldValue("city", "");
//                                               } else {
//                                                 setFieldValue(e.target.name, e.target.value);
//                                               }
//                                             }
//                                           }}
//                     value={values.country || props?.instance?.instance?.country_id}
//                     className={editableFieldClass}
//                     disabled={!isEditing}
//                   >
//                     <option value={props?.instance?.instance?.country_id}>
//                       {/* {props?.instance?.instance?.country_name || "Select a country"} */}
//                       {props?.instance?.instance?.country_name
//                         ? props.instance.instance.country_name
//                         : "Select a country"}
//                     </option>
//                     {country?.map((item) => (
//                       <option key={item._id} value={item._id} data-id={item._id}>
//                         {item.name}
//                       </option>
//                     ))}
//                   </Field>
//                   <ErrorMessage name="country" component="div" className="text-red-500 text-sm mt-1" />
//                 </div>

//                 <div>
//                   <label htmlFor="city" className="block text-sm font-medium text-gray-700 mb-1">
//                     City
//                   </label>
//                   <Field
//                     as="select"
//                     name="city"
//                     onChange={(e) => isEditing && setFieldValue("city", e.target.value)}
//                     value={values.city || props?.instance?.instance?.city_id}
//                     className={editableFieldClass}
//                     disabled={!isEditing}
//                   >
//                     <option value={props?.instance?.instance?.city_id}>
//                       {props?.instance?.instance?.city_name ?props.instance.instance.city_name : "Select a city"}
//                     </option>
//                     {city?.map((item) => (
//                       <option key={item._id} value={item._id}>
//                         {item.cityName}
//                       </option>
//                     ))}
//                   </Field>
//                   <ErrorMessage name="city" component="div" className="text-red-500 text-sm mt-1" />
//                 </div>

//                 <div>
//                   <label htmlFor="address1" className="block text-sm font-medium text-gray-700 mb-1">
//                     Address 1
//                   </label>
//                   <Field
//                     type="text"
//                     name="address1"
//                     values={props.instance.instance.address1}
//                     onChange={(e) => isEditing && setFieldValue(e.target.name, e.target.value)}
//                     className={editableFieldClass}
//                     placeholder="Enter address line 1"
//                     readOnly={!isEditing}
//                   />
//                   <ErrorMessage name="address1" component="div" className="text-red-500 text-sm mt-1" />
//                 </div>

//                 <div>
//                   <label htmlFor="address2" className="block text-sm font-medium text-gray-700 mb-1">
//                     Address 2
//                   </label>
//                   <Field
//                     type="text"
//                     name="address2"
//                     values={props.instance.instance.address2}
//                     onChange={(e) => isEditing && setFieldValue(e.target.name, e.target.value)}
//                     className={editableFieldClass}
//                     placeholder="Enter address line 2"
//                     readOnly={!isEditing}
//                   />
//                 </div>

//                 <div>
//                   <label htmlFor="pincode" className="block text-sm font-medium text-gray-700 mb-1">
//                     Pincode
//                   </label>
//                   <Field
//                     type="text"
//                     name="pincode"
//                     values={props.instance.instance.pincode}
//                     onChange={(e) => isEditing && setFieldValue(e.target.name, e.target.value)}
//                     className={editableFieldClass}
//                     placeholder="Enter address line 2"
//                     readOnly={!isEditing}
//                   />
//                 </div>
//                 <div>
//                   <label htmlFor="contact_number" className="block text-sm font-medium text-gray-700 mb-1">
//                     Contact Number
//                   </label>
//                   <Field
//                     type="text"
//                     name="contact_number"
//                     values={props.instance.instance.contact_number}
//                     onChange={(e) => isEditing && setFieldValue(e.target.name, e.target.value)}
//                     className={editableFieldClass}
//                     placeholder="Enter contact number"
//                     readOnly={!isEditing}
//                   />
//                   <ErrorMessage name="contact_number" component="div" className="text-red-500 text-sm mt-1" />
//                 </div>

//                 <div>
//                   <label htmlFor="contact_person" className="block text-sm font-medium text-gray-700 mb-1">
//                     Contact Person
//                   </label>
//                   <Field
//                     type="text"
//                     name="contact_person"
//                     values={props.instance.instance.contact_person}
//                     onChange={(e) => isEditing && setFieldValue(e.target.name, e.target.value)}
//                     className={editableFieldClass}
//                     placeholder="Enter contact person name"
//                     readOnly={!isEditing}
//                   />
//                   <ErrorMessage name="contact_person" component="div" className="text-red-500 text-sm mt-1" />
//                 </div>

//                 <div>
//                   <label htmlFor="category" className="block text-sm font-medium text-gray-700 mb-1">
//                     Category
//                   </label>
//                   <Field
//                     as="select"
//                     name="category"
//                     values={props.instance.instance.category}
//                     onChange={(e) => isEditing && setFieldValue(e.target.name, e.target.value)}
//                     className={editableFieldClass}
//                     disabled={!isEditing}
//                   >
//                     <option value="">Select a category</option>
//                     {category?.map((item) => (
//                       <option key={item._id} value={item.category_name}>
//                         {item.category_name}
//                       </option>
//                     ))}
//                   </Field>
//                   <ErrorMessage name="category" component="div" className="text-red-500 text-sm mt-1" />
//                 </div>
//               </div>

//               {isEditing && (
//                 <div className="mt-6 flex justify-end space-x-4">
//                   <button
//                     type="button"
//                     onClick={() => handlecancel({ resetForm })}
//                     variant="outline"
//                     className="bg-black text-white py-1 px-5 rounded-md hover:bg-yellow-600 transition duration-300 ease-in-out"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     disabled={isSubmitting}
//                     className="bg-yellow-600 text-white py-1 px-5 rounded-md hover:bg-black transition duration-300 ease-in-out"
//                   >
//                     {isSubmitting ? "Saving..." : "Save"}
//                   </button>
//                 </div>
//               )}
//             </Form>
//           )}
//         </Formik>
//       </div>
//     </div>
//   )
// }

